import { render, staticRenderFns } from "./SignupDialog.vue?vue&type=template&id=2722e162&scoped=true"
import script from "./SignupDialog.vue?vue&type=script&lang=js"
export * from "./SignupDialog.vue?vue&type=script&lang=js"
import style0 from "./SignupDialog.vue?vue&type=style&index=0&id=2722e162&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2722e162",
  null
  
)

export default component.exports